import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, LoginForm } from "@/pages/_auth";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (user) navigate("/account"); }, [user, navigate]);
  return (
    <AuthShell title="Sign in" subtitle="Continue your study of the civilisation."
      footer={<>New here? <Link to="/register" className="text-indic-gold hover:underline" data-testid="to-register">Create a free account</Link></>}>
      <LoginForm />
    </AuthShell>
  );
}
